import { render, staticRenderFns } from "./MarkVer.vue?vue&type=template&id=14533393&scoped=true"
import script from "./MarkVer.vue?vue&type=script&lang=js"
export * from "./MarkVer.vue?vue&type=script&lang=js"
import style0 from "./MarkVer.vue?vue&type=style&index=0&id=14533393&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14533393",
  null
  
)

export default component.exports